import React, { useMemo, useCallback } from 'react'
import { OrderDetail, TradeConditionFlag } from 'api'
import { AxeTradeConditionButtons } from 'view/shared/entity'
import { GridAxeTradeConditionButtonsProps } from 'view/components/datagrid/renderers/AxeTradeConditionRenderer'
import { OrderFieldNames } from './StagingGridColumnNames'
import { TradingEntityWithAliasHelper } from 'model'
import { Locale, Translation } from 'locale'

interface StagingAxeTradeConditionButtonsProps extends GridAxeTradeConditionButtonsProps<OrderDetail> {}

export const StagingAxeTradeConditionButtons: React.FunctionComponent<StagingAxeTradeConditionButtonsProps> = props => {
  const { data, rowInEdit, onUpdate } = props

  const readOnly = useMemo(
    () =>
      !rowInEdit ||
      !data ||
      !data.counterparty ||
      TradingEntityWithAliasHelper.getName(data.counterparty) === Locale.translate(Translation.SC_MULTIPLE),
    [rowInEdit, data]
  )

  const handleUpdate = useCallback(
    (isAxed: boolean, tradeConditionFlag: TradeConditionFlag, orderDetail: OrderDetail) => {
      if (orderDetail.axeTradeCondition && orderDetail.axeTradeCondition.isAxed !== isAxed) {
        onUpdate(orderDetail.order.orderId, orderDetail, OrderFieldNames.AXE, isAxed)
      }
      if (orderDetail.axeTradeCondition && orderDetail.axeTradeCondition.tradeCondition !== tradeConditionFlag) {
        onUpdate(orderDetail.order.orderId, orderDetail, OrderFieldNames.ROLL_UNWIND, tradeConditionFlag)
      }
    },
    [onUpdate]
  )

  return (
    <AxeTradeConditionButtons
      isAxed={data.axeTradeCondition ? data.axeTradeCondition.isAxed : false}
      tradeConditionFlag={data.axeTradeCondition ? data.axeTradeCondition.tradeCondition : TradeConditionFlag.NONE}
      readOnly={readOnly}
      onUpdate={(isAxed, tradeConditionFlag) => handleUpdate(isAxed, tradeConditionFlag, data)}
      dataTestId={'StagingAxeTradeConditionButtons'}
    />
  )
}
